import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './pages/App';
import AppUserReducer from './pages/AppUseReducer';
import reportWebVitals from './reportWebVitals';
import RangeSlider from './components/RangeSlider';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {/* <RangeSlider className='bg-slate-800 h-40 w-80'/> */}
      <App />
    {/* <Iteration1/> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
